import React, { useState, useEffect } from "react";
import DatePicker from 'react-datepicker';
import axios from "axios";
import './ExistingStockVerificationReport.css'
import jsPDF from "jspdf";
import "jspdf-autotable";
import Select from 'react-select';
import { format } from 'date-fns';
import ExcelJS from 'exceljs';
import pomisHeaderImage from './pomisHeader.jpeg';

import pds from './pds.PNG';
const customStyles = {
    control: (provided) => ({
        ...provided,
        borderRadius: "4px",
        padding: "2px",

    }),
    dropdownIndicator: (provided) => ({
        ...provided,

        cursor: "pointer", // Change cursor to indicate it's clickable
    }),
    indicatorSeparator: () => ({
        display: "none", // Hide the default separator

    }),
};
const ExistingStockVerificationReport = () => {
    const [fpsOptions, setFpsOptions] = useState([]); // Store the fetched FPS options
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [districtUid, setDistrictUid] = useState('');
    const [subDivisionUid, setSubDivisionUid] = useState(''); // Store subdistrictUid for reports
    const [blockUid, setBlockUid] = useState('');
    const [panchayatUid, setPanchayatUid] = useState('');
    const [districtId, setDistrictId] = useState("");
    const [subDivisionId, setSubDivisionId] = useState('');
    const [blockId, setBlockId] = useState('');
    const [districts, setDistricts] = useState([]);
    const [subDivisions, setSubDivisions] = useState([]);
    const [blocks, setBlocks] = useState([]);
    const [panchayatId, setPanchayatId] = useState("");
    const [panchayats, setPanchayats] = useState([]);
    const [fpsId, setFpsId] = useState("");
    const [fpsUniqueId, setFpsUniqueId] = useState("");
    const [fpshops, setFPShops] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [startDate, setStartDate] = useState(null);

    const [showCalendar, setShowCalendar] = useState(false);
    const [showEndCalendar, setShowEndCalendar] = useState(false);
    const [error, setError] = useState(null);  // Define setError here
    const [isOpen, setIsOpen] = useState(false);
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showDownloadButton, setShowDownloadButton] = useState(false);  // Control visibility of DOWNLOAD PDF button
    const [showTable, setShowTable] = useState(false);
    const [stockData, setStockData] = useState([]);
    const [sortedStockData, setSortedStockData] = useState([]);
    // Get the current date and reset time to midnight to avoid time-based issues
    const currentDate = new Date();
    const [endDate, setEndDate] = useState(currentDate);
    currentDate.setHours(0, 0, 0, 0); // Reset time to midnight
    // Determine the minimum date for the endDate date picker
    const currentYear = currentDate.getFullYear();
    const minStartDate = new Date(2025, 0, 1); // January 1st of current year

    const fixedStartDate = new Date(2025, 7, 29); // 29-08-2025 (Month is 0-based: 7 = August)
    const generatePDF = () => {


        const doc = new jsPDF({
            unit: 'mm', // units in mm (millimeters)
            format: [290, 300] // A4 size: 210mm x 297mm (you can customize it to larger size like letter: [216, 279])
        });

        doc.setFontSize(18);
        doc.addImage(pds, 'jpeg', 9.5, -1, 273, 43);  // Image format: 'PNG'
        // Assuming doc is an instance of jsPDF

        const pageWidth = doc.internal.pageSize.width;

        // Set the background color for the title and move it down
        const backgroundYPosition = 40.2; // New y-position for the background fill
        doc.setFillColor(211, 211, 211); // RGB values for 'whitesmoke'
        doc.rect(10, backgroundYPosition, pageWidth - 20, 15, 'F'); // Draw a filled rectangle with the new y-position

        // Set the report title with a styled color
        // Set the report title with a styled color
        const title = 'Existing Stock Verification Report';  // Title for the report

        // Get the page width
        const titleWidth = doc.getTextWidth(title); // Get the width of the title

        // Set title text color to #2a6d8b
        doc.setTextColor(42, 109, 139);  // RGB values for #2a6d8b
        doc.setFontSize(14.4);

        // Increase the y-position to move the title further down
        const titleYPosition = backgroundYPosition + 10; // Adjusted y-position for the title, below the background

        // Draw the title text in the center of the page
        doc.text(title, (pageWidth - titleWidth) / 2, titleYPosition); // Position the title at the new y position

        // Mapping IDs to names for each field
        const district = districts.find(d => String(d.id) === String(districtId));
        const subDivision = subDivisions.find(s => String(s.id) === String(subDivisionId));
        const block = blocks.find(b => String(b.id) === String(blockId));
        const panchayat = panchayats.find(p => String(p.id) === String(panchayatId));
        const fps = fpshops.find(f => String(f.id) === String(fpsUniqueId));
        //const fpsName = fps ? fps.fpsId : fpsUniqueId; // This line uses fpsId from the found object or falls back to fpsUniqueId.

        // const fps = Object.values(fpshops).find(f => String(f.id) === String(fpsUniqueId));
        const districtName = district ? district.districtName : '';
        const subDivisionName = subDivision ? subDivision.subDivisionName : '';
        const blockName = block ? block.blockName : '';
        const panchayatName = panchayat ? panchayat.panchayatName : '';
        const fpsName = fps ? fps.fpsId : fpsUniqueId; // If not found in fpshops, use the typed fpsId
        //console.log("fpsName:", fpsName);
        // console.log(fpsUniqueId);
        // console.log(" fpsId:", fpsUniqueId);

        // Date formatting (if dates are present)
        const fromDate = startDate ? `${startDate.getDate().toString().padStart(2, '0')}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear().toString().slice()}` : '';
        const toDate = endDate ? `${endDate.getDate().toString().padStart(2, '0')}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear().toString().slice()}` : '';

        // Set the font size and text color for the content
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);  // Set text color to black

        let currentYPosition = 55.21;
        let xPosition = 10;
        const columnSpacing = 90; // Space between columns

        // Check if there is data for each table
        const hasDistrict = districtName !== '';
        const hasSubDivision = subDivisionName !== '';
        const hasBlock = blockName !== '';

        const hasPanchayat = panchayatName !== '';
        const hasFps = fpsName !== '';

        const hasFromDate = fromDate !== '';
        const hasToDate = toDate !== '';

        // First Table (District, Sub Division, Block)
        if (hasDistrict || hasSubDivision || hasBlock) {
            // First Table (District, Sub Division, Block)
            doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the first table

            // Set font to normal for labels
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);

            // Add labels only if data exists for the fields
            if (hasDistrict) {
                doc.text("District:", xPosition + 5, currentYPosition + 5);
            }
            if (hasSubDivision) {
                doc.text("Sub Division:", xPosition + columnSpacing + 15, currentYPosition + 5);
            }
            if (hasBlock) {
                doc.text("Block:", xPosition + columnSpacing * 2.02, currentYPosition + 5);
            }


            doc.setFont("helvetica", "bold");
            doc.setTextColor(0, 0, 0);  // Blue color for dynamic data

            // Add dynamic data only if the corresponding field exists
            if (hasDistrict) {
                doc.text(districtName, xPosition + 28, currentYPosition + 5);  // District name (dynamic)
            }
            if (hasSubDivision) {
                doc.text(capitalizeFirstLetter(subDivisionName), xPosition + columnSpacing + 45, currentYPosition + 5);  // Sub Division name (dynamic)
            }
            if (hasBlock) {
                doc.text(blockName, xPosition + columnSpacing * 1.92 + 28, currentYPosition + 5);  // Block name (dynamic)
            }


            currentYPosition += 8;  // Move down for the next row

            // Second Table (Panchayat, FPS ID)
            if (hasPanchayat || hasFps) {
                // Second Table (Panchayat, FPS ID)
                doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the second table

                // Set font to normal for labels (Panchayat, FPS ID)
                doc.setFont("helvetica", "normal");
                doc.setTextColor(0, 0, 0);  // Set text color to black for labels

                // Add labels only if data exists
                if (hasPanchayat) {
                    doc.text("Panchayat:", xPosition + 5, currentYPosition + 5);
                }
                if (hasFps) {
                    doc.text("FPS ID:", xPosition + columnSpacing + 15, currentYPosition + 5);
                }


                doc.setFont("helvetica", "bold");
                doc.setTextColor(0, 0, 0);  // Green color for dynamic data

                // Add dynamic data only if the corresponding field exists
                if (hasPanchayat) {
                    let firstName = panchayatName;
                    doc.text(firstName, xPosition + 28, currentYPosition + 5);  // Panchayat name (first name)
                }
                if (hasFps) {
                    doc.text(fpsName, xPosition + columnSpacing + 45, currentYPosition + 5);  // FPS ID (dynamic)
                }


                currentYPosition += 8;  // Move down for the next row

                // If third table has data, show it
                if (hasFromDate || hasToDate) {
                    // Third Table (From Date, To Date)
                    doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

                    // Set font to normal for labels (From Date, To Date)
                    doc.setFont("helvetica", "normal");
                    doc.setTextColor(0, 0, 0);  // Set text color to black for labels


                    // Add labels for From Date and To Date
                    if (hasFromDate) {
                        doc.text("From Date:", xPosition + 5, currentYPosition + 5);
                    }
                    if (hasToDate) {
                        doc.text("To Date:", xPosition + columnSpacing + 15, currentYPosition + 5);
                    }


                    doc.setFont("helvetica", "bold");
                    doc.setTextColor(0, 0, 0);  // Orange color for dynamic data

                    // Add dynamic data for From Date and To Date
                    if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
                    if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 45, currentYPosition + 5);  // To Date (dynamic)


                    currentYPosition += 8;  // Move down for the next row
                }
            }

            // If second table has no data, show third table (From Date, To Date)
            else if (!hasPanchayat && !hasFps && (hasFromDate || hasToDate)) {
                // Third Table (From Date, To Date)
                doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

                // Set font to normal for labels (From Date, To Date)
                doc.setFont("helvetica", "normal");
                doc.setTextColor(0, 0, 0);  // Set text color to black for labels

                // Add labels for From Date and To Date
                if (hasFromDate) {
                    doc.text("From Date:", xPosition + 5, currentYPosition + 5);
                }
                if (hasToDate) {
                    doc.text("To Date:", xPosition + columnSpacing + 15, currentYPosition + 5);
                }

                doc.setFont("helvetica", "bold");
                doc.setTextColor(0, 0, 0);  // Orange color for dynamic data

                // Add dynamic data for From Date and To Date
                if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
                if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 45, currentYPosition + 5);  // To Date (dynamic)

                currentYPosition += 8;  // Move down for the next row
            }
        }

        // If the first table has no data, show second table (Panchayat, FPS ID) if it has data
        else if (hasPanchayat || hasFps) {
            // Second Table (Panchayat, FPS ID)
            doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the second table

            // Set font to normal for labels (Panchayat, FPS ID)
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);  // Set text color to black for labels

            // Add labels only if data exists
            if (hasPanchayat) {
                doc.text("Panchayat:", xPosition + 5, currentYPosition + 5);
            }
            if (hasFps) {
                doc.text("FPS ID:", xPosition + columnSpacing + 15, currentYPosition + 5);
            }

            doc.setFont("helvetica", "bold");
            doc.setTextColor(0, 0, 0);  // Green color for dynamic data

            // Add dynamic data only if the corresponding field exists
            if (hasPanchayat) {
                let firstName = panchayatName;
                doc.text(firstName, xPosition + 28, currentYPosition + 5);  // Panchayat name (first name)
            }
            if (hasFps) {
                doc.text(fpsName, xPosition + columnSpacing + 45, currentYPosition + 5);  // FPS ID (dynamic)
            }


            currentYPosition += 8;  // Move down for the next row

            // If third table has data, show it
            if (hasFromDate || hasToDate) {
                // Third Table (From Date, To Date)
                doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

                // Set font to normal for labels (From Date, To Date)
                doc.setFont("helvetica", "normal");
                doc.setTextColor(0, 0, 0);  // Set text color to black for labels


                // Add labels for From Date and To Date
                if (hasFromDate) {
                    doc.text("From Date:", xPosition + 5, currentYPosition + 5);
                }
                if (hasToDate) {
                    doc.text("To Date:", xPosition + columnSpacing + 15, currentYPosition + 5);
                }

                doc.setFont("helvetica", "bold");
                doc.setTextColor(0, 0, 0);  // Orange color for dynamic data

                // Add dynamic data for From Date and To Date
                if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
                if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 45, currentYPosition + 5);  // To Date (dynamic)

                currentYPosition += 8;  // Move down for the next row
            }
        }

        // If the second table has no data, show the third table (From Date, To Date)
        else if (hasFromDate || hasToDate) {
            // Third Table (From Date, To Date)
            doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

            // Set font to normal for labels (From Date, To Date)
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);  // Set text color to black for labels

            // Add labels for From Date and To Date
            if (hasFromDate) {
                doc.text("From Date:", xPosition + 5, currentYPosition + 5);
            }
            if (hasToDate) {
                doc.text("To Date:", xPosition + columnSpacing + 15, currentYPosition + 5);
            }


            doc.setFont("helvetica", "bold");
            doc.setTextColor(0, 0, 0);  // Orange color for dynamic data
            // Add dynamic data for From Date and To Date
            if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
            if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 45, currentYPosition + 5);  // To Date (dynamic)

            currentYPosition += 8;  // Move down for the next row
        }

        currentYPosition += 5;  // Adjust space for next content if needed

        // Get the current date and time
        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;

        // Set the date text color (black) and make it bold
        doc.setFont('helvetica', 'bold'); // Use Helvetica font and bold style
        doc.setTextColor(0, 0, 0);  // Black color for the date
        doc.setFontSize(12);

        // Set the position for the current date and time
        // const dateYPosition = titleYPosition+35; // Position the date just below the title

        // Add the current date and time to the PDF, positioned at the bottom-right corner
        doc.text(`Report Date: ${formattedDateTime}`, pageWidth - 11, currentYPosition + 8, { align: 'right' });
        currentYPosition += 5;

        currentYPosition += 5;  // Adjust space for next content if needed

        // Table Column Titles
        const headers = [
            [
                { content: 'S. No', rowSpan: 2 },
                { content: 'District', rowSpan: 2 },
                { content: 'Sub Division', rowSpan: 2 },
                { content: 'Block', rowSpan: 2 },
                { content: 'Panchayat', rowSpan: 2 },
                { content: 'Officer Name', rowSpan: 2 },
                { content: 'Date of Inspection', rowSpan: 2 },
                { content: 'FPS ID', rowSpan: 2 },
                { content: 'e-POS Stock Rice(Qtl)', colSpan: 2 },
                { content: 'e-POS Stock Wheat(Qtl)', colSpan: 2 },
                { content: 'Physically Verified Quantity(Qtl)', colSpan: 2 },
                { content: 'Difference in ePos and Physical Stock(Qtl)', colSpan: 2 },
            ],
            // Second row (sub-headers)
            [
                { content: 'PHH Qty' },
                { content: 'AAY Qty' },
                { content: 'PHH Qty' },
                { content: 'AAY Qty' },
                { content: 'Rice' },
                { content: 'Wheat' },
                { content: 'Rice' },
                { content: 'Wheat' },
            ],


        ];
        // Repeat the stockData 15 times

        // Prepare the data rows for the table
        const rows = stockData.map((data, index) => [
            index + 1,
            capitalizeFirstLetter(data.districtName),
            capitalizeFirstLetter(data.subDivisionName),
            capitalizeFirstLetter(data.blockName),
            capitalizeFirstLetter(data.panchayatName),
            formatFullName(data.officerName),
            new Date(data.startTime).toLocaleDateString('en-GB').replace(/\//g, '-'),
            data.fpsId,
            data.phhRice || 'N/A',
            data.aayRice || 'N/A',
            data.phhWheat || 'N/A',
            data.aayWheat || 'N/A',
            data.ricePhysical || 'N/A',
            data.wheatPhysical || 'N/A',
            // data.wheatDiff||'N/A',
            parseFloat(data.riceDiff || 'N/A').toFixed(2),
            parseFloat(data.wheatDiff || 'N/A').toFixed(2),



        ]);

        // AutoTable Plugin - Adding Table to PDF
        doc.autoTable({
            head: headers,
            body: rows,
            startY: currentYPosition,

            theme: 'grid',
            headStyles: {
                fontStyle: 'bold',  // Make the header text bold
                textColor: [12, 92, 108],  // White text color for header
                fillColor: [242, 242, 242],  // White text color
                fontSize: 10,
            },
            margin: { top: 30, left: 7 },
            columnStyles: {
                0: { cellWidth: 11.5, halign: 'center' },   // S. No.
                1: { cellWidth: 16, halign: 'left' },   // Block
                2: { cellWidth: 20, halign: 'left' },   // Panchayat
                3: { cellWidth: 22, halign: 'left' },   // Date of Inspection
                4: { cellWidth: 21, halign: 'left' },   // Inspection Officer
                5: { cellWidth: 26.5, halign: 'left' },   // FPS ID
                6: { cellWidth: 22, halign: 'right' },   // Wheat PHH
                7: { cellWidth: 15, halign: 'right' },   // Wheat AYY
                8: { cellWidth: 15, halign: 'right' },   // Rice PHH
                9: { cellWidth: 15, halign: 'right' },   // Rice AYY
                10: { cellWidth: 15, halign: 'right' },  // Physical Stock Rice
                11: { cellWidth: 15, halign: 'right' },  // Physical Stock Wheat
                12: { cellWidth: 15, halign: 'right' },  // Stock Difference Rice
                13: { cellWidth: 15, halign: 'right' },  // Stock Difference Wheat
                14: { cellWidth: 15, halign: 'right' },  // Stock Difference Rice
                15: { cellWidth: 15, halign: 'right' },  // Stock Difference Wheat


            },

        });

        // Save the PDF
        doc.save("ExistingStockVerificationReport.pdf");


    };
    const generateXl = () => {
        // 1. Get the current date in DD-MM-YYYY format
        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;
        // 2. Generate Excel file using ExcelJS
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Existing Stock Verification Report');
        worksheet.mergeCells('A1:R1'); // Merge cells for the title
        worksheet.getCell('A1').value = `FPS ATR Entry Form`; // Add spaces before date to shift it

        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('A1').font = { size: 16, bold: true, color: { argb: 'F7912B' } };  // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getCell('A1').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
        };

        worksheet.mergeCells('A2:R2'); // Merge cells for the title
        worksheet.getCell('A2').value = `Report Date: ${formattedDateTime}`; // Add spaces before date to shift it

        worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'right' };
        worksheet.getCell('A2').font = { size: 13, bold: true, color: { argb: '00000' } };  // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getCell('A2').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
        };
        const fromDate = startDate ? `${startDate.getDate().toString().padStart(2, '0')}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear().toString().slice()}` : '';
        const toDate = endDate ? `${endDate.getDate().toString().padStart(2, '0')}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear().toString().slice()}` : '';

        worksheet.mergeCells('A3:R3'); // Merge cells for the title
        worksheet.getCell('A3').value = `From Date: ${fromDate}                  To Date: ${toDate}`; // Add spaces before date to shift it

        worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'left' };
        worksheet.getCell('A3').font = { size: 13, bold: true, color: { argb: '00000' } };  // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getCell('A3').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
        };
        // Define the header row
        // Define the header row with merged cells for multi-column headers
        worksheet.addRow([
            "S.No",
            "District",
            "SubDivision",
            "Block",
            "Panchayat",
            "Officer Name",
            "Date of Inspection",
            "FPS ID",
            "Dealer Name",
            "Stock Difference (Rice) QTL",
            "Stock Difference (Wheat) QTL",
            "Type of Deviation (Excess / Shortfall)",
            "Less Quantity of Grain Distributed",
            "Bad Quality of Food Grains Distributed ",
            "Food Grains Not Distributed for Current Month",
            "Action Initiated",
            "Status",
            "Remarks",
        ]);

        // // Merge header cells for multi-column headers (e.g., "e-POS Stock Wheat" spans 2 columns)
        // worksheet.mergeCells('I4:J4'); // Merges columns H and I for "e-POS Stock Wheat"
        // worksheet.mergeCells('K4:L4'); // Merges columns J and K for "e-POS Stock Rice"
        // worksheet.mergeCells('M4:N4'); // Merges columns L and M for "Physically Verified Quantity"
        // worksheet.mergeCells('O4:P4'); // Merges columns N and O for "Difference in ePos and Physical Stock"

        // // Adding sub-headers with the row spans and column spans
        // worksheet.addRow([
        //     "",  // S.No
        //     "",  // District
        //     "",  // SubDivision
        //     "",  // Block
        //     "",  // Panchayat
        //     "",  // Officer Name
        //     "",  // Date of Inspection
        //     "",  // FPS ID

        //     "PHH Qty",  // e-POS Stock Wheat - PHH
        //     "AAY Qty",  // e-POS Stock Wheat - AYY
        //     "PHH Qty",  // e-POS Stock Rice - PHH
        //     "AAY Qty",  // e-POS Stock Rice - AYY
        //     "Rice",     // Physically Verified Quantity - Rice
        //     "Wheat",    // Physically Verified Quantity - Wheat
        //     "Rice",     // Difference in ePos and Physical Stock - Rice
        //     "Wheat"     // Difference in ePos and Physical Stock - Wheat
        // ]);

        // Apply header style: bold, size 12, and orange background
        worksheet.getRow(4).font = { bold: true, size: 12 };
        // worksheet.getRow(5).alignment = { horizontal: 'center' }; // Center alignment
        // worksheet.getRow(5).alignment = { horizontal: 'center' };
        // Apply background color to the first row (header row)
        for (let col = 1; col <= 18; col++) {
            const cell = worksheet.getCell(4, col); // Get each cell in the first row (header)
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' }  // Orange background color
            };
            // Apply font styling: bold and size 12
            cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
            // Add border to header cells
            cell.border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };
        }
        // for (let col = 1; col <= 20; col++) {
        //     const cell = worksheet.getCell(5, col); // Get each cell in the first row (header)
        //     cell.fill = {
        //         type: 'pattern',
        //         pattern: 'solid',
        //         fgColor: { argb: 'FFFFA500' }  // Orange background color
        //     };
        //     // Apply font styling: bold and size 12
        //     cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
        //     // Add border to header cells
        //     cell.border = {
        //         top: { style: 'thin', color: { argb: '000000' } },
        //         left: { style: 'thin', color: { argb: '000000' } },
        //         bottom: { style: 'thin', color: { argb: '000000' } },
        //         right: { style: 'thin', color: { argb: '000000' } }
        //     };
        // }

        // Adjust column widths (ensure to set widths based on your content)
        worksheet.columns = [
            { key: 'A', width: 10 },  // Column A: S.No
            { key: 'B', width: 20 },  // Column B: District
            { key: 'C', width: 25 },  // Column C: SubDivision
            { key: 'D', width: 25 },  // Column D: Block
            { key: 'E', width: 25 },  // Column E: Panchayat

            { key: 'F', width: 25 },  // Column F: Officer Name
            { key: 'G', width: 30 },  // Column G: Date of Inspection
            { key: 'H', width: 25 },  // Column F: FPS ID
            { key: 'I', width: 20 },  // Column H: e-POS Stock Wheat
            { key: 'J', width: 20 },  // Column I: e-POS Stock Wheat (AYY Qty)
            { key: 'K', width: 20 },  // Column J: e-POS Stock Rice
            { key: 'L', width: 20 },  // Column K: e-POS Stock Rice (AYY Qty)
            { key: 'M', width: 25 },  // Column L: Physically Verified Quantity (Rice, Wheat)
            { key: 'N', width: 20 },  // Column M: Difference in ePos and Physical Stock (Rice, Wheat)
            { key: 'O', width: 25 },
            { key: 'P', width: 25 },
            { key: 'Q', width: 30 },
            { key: 'R', width: 40 },
            { key: 'S', width: 30 },
            { key: 'T', width: 20 },

        ];
        // Add data rows
        stockData.forEach((data, index) => {
            const dataRow = worksheet.addRow([
                index + 1,
                capitalizeFirstLetter(data.districtName),
                capitalizeFirstLetter(data.subDivisionName),
                capitalizeFirstLetter(data.blockName),
                capitalizeFirstLetter(data.panchayatName),
                formatFullName(data.officerName),
                new Date(data.dateofInspection).toLocaleDateString('en-GB').replace(/\//g, '-'),
                data.fpsId,
                formatFullName(data.dealerName || 'N/A'),
                data.riceDifference || '-',
                data.wheatDifference || '-',


                data.typeofDeviation && data.typeofDeviation !== "No Difference"
                    ? data.typeofDeviation
                    : "-",
                // data.wheatDiff||0,
                capitalizeWords(data.lessQuantity || 'N/A'),
                capitalizeWords(data.badQuality || 'N/A'),
                capitalizeWords(data.notDistributed || 'N/A'),
                data.actionInitiated || 'N/A',
                data.status || 'N/A',

            ]);

            // Apply alignment for each cell in the data row
            dataRow.eachCell((cell, colNumber) => {
                if (colNumber === 1) {
                    // Center alignment for S.No (Serial Number)
                    cell.alignment = { horizontal: 'center' };
                } else if (colNumber >= 2 && colNumber <= 6) {
                    // Left alignment for District to Officer Name (columns 2 to 6)
                    cell.alignment = { horizontal: 'left' };
                } else if (colNumber >= 7 && colNumber <= 16) {
                    // Right alignment for Date of Inspection to Difference in ePos and Physical Stock (columns 7 to 16)
                    cell.alignment = { horizontal: 'right' };
                }
            });
        });



        // Save the file (Excel)
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'Beneficiary_Feedback_Based_Action_Entry_Form.xlsx';
            link.click();
        });

    };



    const handleStartDateChange = (date) => {
        setStartDate(date);       // Set the selected start date
        setEndDate('');           // Clear the end date when start date changes
        setShowCalendar(false);   // Hide the calendar after selection
        setShowTable(false);
    };


    const handleEndDateIconClick = () => {
        // Only show the calendar for endDate if startDate is selected
        if (startDate) {
            setShowEndCalendar(true);
        }
    };
    // Handle the end date change
    const handleEndDateChange = (date) => {
        setEndDate(date);
        setShowEndCalendar(false);
        setShowTable(false);
    };

    // Token you provided (for testing purposes)
    const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
    const baseUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api`;

    useEffect(() => {
        if (token) {
            axios
                .get(`${baseUrl}/districts?pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((response) => {
                    if (response.data && response.data.data && Array.isArray(response.data.data)) {

                        setDistricts(response.data.data);
                        const updatedDistricts = [
                            { district: 'All', districtName: 'All Districts', districtUid: null }, // 'All' option
                            ...response.data.data
                        ];

                        setDistricts(updatedDistricts); // Set the updated districts with 'All'
                    } else {
                        setError("Invalid response format");
                    }


                })
                .catch((error) => {
                    setError("Error fetching districts");
                    console.error("Error fetching districts:", error);
                });
        } else {
            setError("No token found. Please log in.");
        }
    }, [token]);

    const fetchSubDivisions = async (districtId) => {
        if (districtId) {
            try {
                const response = await axios.get(`${baseUrl}/sub-divisions?filters[district][id][$eq]=${districtId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setSubDivisions(response.data.data || []);
            } catch (error) {
                setError("Error fetching sub-divisions");
            }
        } else {
            setSubDivisions([]);
        }
    };



    const fetchBlocks = async (subDivisionId) => {
        if (subDivisionId) {
            try {
                const response = await axios.get(`${baseUrl}/blocks?filters[subDivision][id][$eq]=${subDivisionId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setBlocks(response.data.data || []);
            } catch (error) {
                setError("Error fetching blocks");
            }
        } else {
            setBlocks([]);
        }
    };




    const fetchPanchayats = async (blockId) => {
        if (blockId) {
            try {
                const response = await axios.get(`${baseUrl}/panchayats?filters[block][id][$eq]=${blockId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setPanchayats(response.data.data || []);
            } catch (error) {
                setError("Error fetching panchayats");
            }
        } else {
            setPanchayats([]);
        }
    };

    const fetchFPSOptions = async () => {
        setIsLoading(true); // Show loading indicator

        // Construct request payload
        const requestData = {};

        if (districtUid) {
            requestData.district = districtUid;
        }
        if (subDivisionUid) {
            requestData.subDivision = subDivisionUid;
        }
        if (blockUid) {
            requestData.block = blockUid;
        }
        if (panchayatUid) {
            requestData.panchayat = panchayatUid;
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_AUDIT_API_URL}/api/fps/get-by-state-details`, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response.data && response.data.data) {
                setFpsOptions(response.data.data); // Set the fetched FPS options
            } else {
                setFpsOptions([]);
                setError("No FPS data found for the selected filters.");
            }
        } catch (error) {
            setError("Error fetching FPS options.");
            console.error('Error fetching FPS options:', error);
        } finally {
            setIsLoading(false); // Hide loading indicator
        }
    };

    useEffect(() => {
        // Fetch FPS options whenever the filters change
        if (districtUid || subDivisionUid || blockUid || panchayatUid) {
            fetchFPSOptions();
        }
    }, [districtUid, subDivisionUid, blockUid, panchayatUid]);

    const handleFpsSelection = (selectedFpsId) => {
        setFpsId(selectedFpsId); // Store the selected FPS ID
    };

    const handleDistrictChange = (selectedOption) => {
        const selectedDistrictId = selectedOption ? selectedOption.value : '';  // districtId for filtering
        const selectedDistrictUid = selectedOption ? selectedOption.districtUid : '';  // districtUid for reports

        // console.log('Selected District ID (for filtering):', selectedDistrictId);  // for filtering
        // console.log('Selected District UID (for report generation):', selectedDistrictUid);  // for report generation

        // Set both districtId (for filtering) and districtUid (for report generation)
        setDistrictId(selectedDistrictId);  // For filtering
        setDistrictUid(selectedDistrictUid);  // For report generation

        // Reset everything except subdivision
        setSubDivisionUid('');  // Clear subDivisionUid
        setPanchayatUid('');  // Clear panchayatUid
        setBlockUid('');
        setFpsUniqueId('')

        setSubDivisionId('');  // Reset sub-division
        setBlockId('');  // Reset block
        setPanchayatId('');  // Reset panchayat
        setFpsId('');  // Reset FPS ID
        setFPShops([]);  // Clear FPS shops
        setPanchayats([])
        setBlocks([])
        setShowTable(false);  // Reset table visibility
        fetchSubDivisions(selectedDistrictId);  // Fetch subdivisions based on the selected district
    };

    const handleSubDivisionChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectdSubDivisionUid = selectedOption ? selectedOption.subDivisionUid : "";
        //console.log('Selected Subdivision:', selectedId);
        //console.log('Selected selectdSubDivisionUid:', selectdSubDivisionUid);
        // Reset everything except block
        setSubDivisionUid(selectdSubDivisionUid)
        // setSubDivisionUid('');  // Clear subDivisionUid
        setPanchayatUid('');  // Clear panchayatUid
        setBlockUid('');
        setFpsUniqueId('')

        setSubDivisionId(selectedId);
        setBlockId('');  // Reset block
        setPanchayatId('');  // Reset panchayat
        setFpsId('');  // Reset FPS ID
        setFPShops([]);  // Clear FPS shops 
        setPanchayats([])  //it is not actved panchayats without selecting
        setBlocks([]) //it is not actved block  without selecting
        setShowTable(false);  // Reset table visibility
        fetchBlocks(selectedId);  // Fetch blocks based on the selected subdivision
    };

    const handleBlockChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectedBlockUid = selectedOption ? selectedOption.blockUid : '';
        // console.log('Selected Block:', selectedId);
        // console.log('Selected BlockUid:', selectedBlockUid);
        // Reset everything except panchayat
        setBlockId(selectedId);
        setBlockUid(selectedBlockUid);

        setPanchayatUid('');  // Clear panchayatUid

        setFpsUniqueId('')

        setPanchayatId('');  // Reset panchayat
        setFpsId('');  // Reset FPS ID
        setFPShops([]);  // Clear FPS shops without selecting
        setPanchayats([])  //it is not actved panchayats  without selecting
        setShowTable(false);  // Reset table visibility
        fetchPanchayats(selectedId);  // Fetch panchayats based on the selected block
    };

    const handlePanchayatChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectedpanchayatUid = selectedOption ? selectedOption.panchayatUid : '';
        //console.log('Selected Panchayat:', selectedId);
        //  console.log("selected panUid", selectedpanchayatUid);
        setPanchayatUid(selectedpanchayatUid);
        // Reset only FPS ID, as panchayat is selected
        setPanchayatId(selectedId);


        setFpsUniqueId('')

        setFpsId('');  // Reset FPS ID
        setFPShops([]);  // Clear FPS shops not accepting fps without selecting
        setShowTable(false);  // Reset table visibility
        // fetchFPShops(selectedId);  // Fetch FPS shops based on the selected panchayat
    };

    const handleFpsId = (selectedOption) => {
        const selectedFpsId = selectedOption ? selectedOption.value : '';
        const selectedFpsUniqueId = selectedOption ? selectedOption.label : '';

        //console.log('Selected FPS:', selectedFpsId);
        // console.log('unique normal ', selectedFpsUniqueId)
        setFpsId(selectedFpsId);  // Save the selected FPS ID
        setFpsUniqueId(selectedFpsUniqueId);  // Save the selected FPS Unique ID
        setShowTable(false);  // Show the table after FPS ID is selected
    };

    // Function to clear all data (reset state)
    const handleClear = () => {
        setFpsId('');
        setDistrictUid('');
        setDistrictId('');
        setSubDivisionId('');
        setBlockId('');
        setPanchayatId('');
        //  setStartDate('');
        // setEndDate('');
        setShowDownloadButton(false);
        setShowTable(false);
        handleDropdownChange();

        // handleSubmit();
    };


    const handleGenerateReport = () => {

        if (startDate && endDate && startDate > endDate) {
            setError("Start date cannot be later than end date.");
            alert("Start date cannot be later than end date.");
            return;
        }
        // Set loading state before making the request
        setIsLoading(true);  // Show loading message immediately
        setShowTable(true);
        setStockData([]);  // Clear previous data

        const formatDate = (date) => {
            if (!date) return null;
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
            const year = date.getFullYear();
            return `${year}-${month}-${day}`;
        };

        // Prepare request data
        const requestData = {};

        // Add startDate and endDate to the requestData if available
        if (fixedStartDate) {
            requestData.startDate = formatDate(fixedStartDate);
        }

        if (endDate) {
            requestData.endDate = formatDate(endDate);
        }

        // Add districtId to the requestData if selected
        // Add districtId to the requestData if selected (only if needed)
        if (districtUid) {
            requestData.districtUid = districtUid;
        } else if (!districtUid && !fpsId && !fpsUniqueId) {
            // If no fpsId and no districtUid, set default as "All"
            requestData.districtUid = "All";
        }

        // Add other optional parameters like subDivision, block, panchayat, fpsId
        if (subDivisionUid) {
            requestData.subDivisionUid = subDivisionUid;
        }

        if (blockUid && blockUid !== "") {
            requestData.blockUid = blockUid;
        }

        if (panchayatUid && panchayatUid !== "") {
            requestData.panchayatUid = panchayatUid;
        }

        if (fpsUniqueId) {
            requestData.fpsId = fpsUniqueId;  // Use fpsUniqueId if it's available
        } else if (fpsId) {
            requestData.fpsId = fpsId;  // Otherwise, use fpsId
        }


        //console.log(requestData);  // Log the request data for debugging


        // Make the POST request to fetch the report
        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/reports/action-taken-response`, requestData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })

            .then((response) => {
                setIsLoading(false);

                if (response.data && response.data.length > 0) {
                    const filteredData = response.data.filter((item) => {
                        const hasYesFlag =
                            item.lessQuantity === "YES" ||
                            item.badQuality === "YES" ||
                            item.notDistributed === "YES"||
                            item.shopClosed==="YES";
                        const validDeviation =
                            item.typeofDeviation?.trim() === "Shortfall" ||
                            item.typeofDeviation?.trim() === "Excess";

                        const validAction = item.actionInitiated === null;

                        // If any one condition is satisfied (Shortfall/Excess OR YES flag), include it
                        return (validDeviation || hasYesFlag) && validAction;
                    });

                    console.log("Filtered Data:", filteredData);

                    setStockData(filteredData);
                    setShowDownloadButton(filteredData.length > 0);
                    setShowTable(true);
                } else {
                    setStockData([]);
                    setError("Loading...");
                    setShowDownloadButton(false);
                    setShowTable(true);
                }
            })

            .catch((error) => {
                setIsLoading(false);
                setError("Error fetching report.");
                console.error('Error fetching report:', error);
                setShowDownloadButton(false); // Hide download button if there was an error
                setShowTable(true); // Show the table even if there's an error
            });


    };

    const sortData = (data) => {
        return data.sort((a, b) => {
            const districtA = a.districtName || '';
            const districtB = b.districtName || '';
            const subDivisionA = a.subDivisionName || '';
            const subDivisionB = b.subDivisionName || '';
            const blockA = a.blockName || '';
            const blockB = b.blockName || '';
            const panchayatA = a.panchayatName || '';
            const panchayatB = b.panchayatName || '';

            // Sorting order: first district, then sub-division, then block, and finally panchayat
            if (districtA < districtB) return -1;
            if (districtA > districtB) return 1;
            if (subDivisionA < subDivisionB) return -1;
            if (subDivisionA > subDivisionB) return 1;
            if (blockA < blockB) return -1;
            if (blockA > blockB) return 1;
            if (panchayatA < panchayatB) return -1;
            if (panchayatA > panchayatB) return 1;
            return 0;
        });
    };

    // Sorted data before rendering
    // const sortedStockData = sortData(stockData);
    // ✅ update sortedStockData whenever stockData changes
    useEffect(() => {
        if (stockData && stockData.length > 0) {
            setSortedStockData(sortData([...stockData]));
        }
    }, [stockData]);
    const capitalizeFirstLetter = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    const formatFullName = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text
                .split(' ') // Split the string by spaces into words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
                .join(' '); // Join the words back into a single string with spaces
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    // Controlled dropdown open/close
    const toggleDropdown = () => {
        setIsOpen((prevState) => !prevState);
    };

    const formatNumber = (number) => {
        return new Intl.NumberFormat('en-IN').format(number); // 'en-IN' for Indian number formatting (commas at appropriate positions)
    };
    // Step 1: Initialize with sorted existingStock data
    useEffect(() => {
        if (stockData && stockData.length > 0) {
            setSortedStockData(sortData(stockData));
        }
    }, [stockData]);

    // Step 2: Dropdown change handler (already correct)
    // const handleDropdownChange = (rowIndex, field, value) => {
    //     setSortedStockData((prevData) => {
    //         const updatedData = [...prevData];
    //         updatedData[rowIndex] = {
    //             ...updatedData[rowIndex],
    //             [field]: value,
    //         };
    //         return updatedData;
    //     });
    // };
    const [selectedRows, setSelectedRows] = React.useState(new Set());

    // const handleDropdownChange = (index, field, value) => {
    //     const newData = [...sortedStockData];
    //     newData[index] = { ...newData[index], [field]: value };
    //     setSortedStockData(newData);

    //     // Mark this row as selected
    //     setSelectedRows(prev => new Set(prev).add(index));
    // };
    const handleDropdownChange = (index, field, value) => {
        const newData = [...sortedStockData];
        newData[index] = { ...newData[index], [field]: value };
        setSortedStockData(newData);

        // Mark this row as selected
        setSelectedRows(prev => new Set(prev).add(index));
    };

    const formatDeviation = (value) => {
        const num = parseFloat(value);

        if (isNaN(num) || num === 0) return "-";
        if (num > 0) return "Excess";
        if (num < 0) return "Shortfall";

        return "-";
    };
    const actionLabels = {
        notice: "Show Cause Notice",
        revoke: "Show Cause Revoked",
        "cancel license": "Cancellation of License",
    };


    const [userInfo, setUserInfo] = useState({
        // displayName: '',
        // empId: ''
        fullName: '',
        employeeId: '',
        id: '',
        username: '',
    });
    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('user'));
        const loginTime = localStorage.getItem('loginTime');

        if (userData) {
            // Extract the first name from fullName (only the first word)
            const firstName = userData.fullName.split(' ')[0];

            // Set the state with firstName and employeeId
            setUserInfo({
                fullName: firstName,  // Only first name is considered
                employeeId: userData.employeeId,
                id: userData.id,
                username: userData.username,
            });
            setIsLoggedIn(true);
            // setLastLoginDateTime(`Last Login: ${format(new Date(loginTime), 'dd-MM-yyyy | hh:mm:ss a')}`);
        } else {
            setIsLoggedIn(false);
        }
    }, []);
    // const handleSubmit = () => {
    //     const payload = sortedStockData
    //         .filter((entry) => entry.actionInitiated || entry.status) // only updated rows
    //         .map((entry) => ({
    //             officerName: entry.officerName,
    //             inspectionDate: entry.startTime,
    //             fpsId: entry.fpsId,
    //             surveyId: entry.id, // Assuming each entry has a unique 'id' field
    //             actionInitiated: entry.actionInitiated || "",
    //             status: entry.status || "",
    //             // ✅ Attach logged-in user info
    //             userId: userInfo.id,
    //             username: userInfo.username, // only first name if that's what you store
    //         }));

    //     console.log("✅ Payload to submit:", payload);

    //     axios.post(
    //         `${baseUrl}/reports/existing-stock-verification-submit`,
    //         payload,
    //         {
    //             headers: {
    //                 Authorization: `Bearer ${token}`,
    //                 "Content-Type": "application/json",
    //             },
    //         }
    //     )
    //         .then(() => {
    //             alert("Existing Stock Verification successfully!");
    //         })
    //         .catch((error) => {
    //             console.error("❌ Error submitting:", error);
    //             alert("Failed to submit stock verification!");
    //         });
    // };
    const capitalizeWords = (str) => {
        if (!str || typeof str !== "string") return "";
        return str
            .toLowerCase()
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };
    const handleSubmit = () => {
        const selectedIndexes = Array.from(selectedRows);

        if (selectedIndexes.length === 0) {
            alert("Please select at least one row before submitting.");
            return;
        }

        const payload = selectedIndexes
            .map(index => sortedStockData[index])
            .filter(entry => entry && entry.actionType && entry.actionType.trim()) // ✅ safe check here
            .map(entry => {
                let status = "";
                let finalAction = null;
                const action = (entry.actionType || "").trim().toLowerCase();

                if (action === "notice" || action==="fir") {
                    status = "open";
                } else if (action === "revoke" || action === "cancel license") {
                    status = "close";
                    finalAction = action;
                }

                return {
                    fairPriceShop: entry.fairPriceShop,
                    poimsUser: userInfo.id,
                    officerUserName: entry.officerUserName,
                    survey: entry.surveryId,
                    actionInitiated: entry.actionType || "",
                    actionStatus: status,
                    remarks: entry.remarksAction || "",
                    ...(finalAction && { finalAction }),
                };
            });

        if (payload.length === 0) {
            alert("No valid rows to submit.");
            return;
        }

        const finalPayload = { data: payload };

        setIsLoading(true);
        axios.post(`${baseUrl}/beneficiary-feedback-actions/create-many`, finalPayload, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
            .then(() => {
                alert("Existing Stock Verification submitted successfully!");

                // Clear selectedRows and reset action data from submitted rows
                const newData = [...sortedStockData];
                selectedIndexes.forEach(index => {
                    if (newData[index]) {
                        newData[index].actionType = "";
                        newData[index].remarksAction = "";
                    }
                });

                setSortedStockData(newData);
                setSelectedRows(new Set());
                // Refresh the table data
                handleGenerateReport();
            })

            .catch((error) => {
                console.error("❌ Error submitting:", error);
                alert("Failed to submit stock verification!");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };



    return (
        <div className="existingStock-repo">
            <div className="existingStock-1-repo">
                <div className="existingStock-card-header-testing-existingStock-repo">FPS ATR Entry Form</div>
                <div className='fps-whole-div'>
                    <div className="existingStock-mainBlock-testing-existingStock-repo">
                        <div className="existingStock-group-cu-testing-existingStock-repo">
                            <label htmlFor="district" className="district-items-testing-existingStock-repo">
                                <span className="asterisk">*</span>District
                            </label>
                            <Select
                                className="search-select"
                                id="district"
                                // Ensure you pass the selected option as an object with value and label
                                value={districts.find((dist) => dist.id === districtId) ? {
                                    value: districts.find((dist) => dist.id === districtId).id,
                                    label: capitalizeFirstLetter(districts.find((dist) => dist.id === districtId).districtName)
                                } : null}
                                onChange={handleDistrictChange}  // Handle the selection change
                                options={districts
                                    .sort((a, b) => a.districtName.localeCompare(b.districtName))  // Sort by districtName alphabetically
                                    .map((dist) => ({
                                        value: dist.id,
                                        label: capitalizeFirstLetter(dist.districtName),
                                        districtUid: dist.districtUid,  // Add districtUid for report generation
                                    }))
                                }
                                placeholder="Select a district"
                                isSearchable // Enable search in the dropdown
                                styles={customStyles} // Apply custom styles here
                                required
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown} // Trigger dropdown open
                                onMenuClose={toggleDropdown} // Trigger dropdown close
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: "pointer", marginRight: "10px" }}>
                                            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange' %3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E" alt="Dropdown" style={{ width: "20px", height: "20px" }} />
                                        </div>
                                    ),
                                }}
                            />
                        </div>


                        <div className="existingStock-group-cu-testing-existingStock-repo">
                            <label htmlFor="subDivision">{/*<span className="asterisk">*</span>*/}Sub Division</label>
                            <Select
                                className="search-select"
                                id="subDivision"
                                value={subDivisionId ? {
                                    value: subDivisionId,
                                    label: capitalizeFirstLetter(subDivisions.find((sub) => sub.id === subDivisionId)?.subDivisionName)
                                } : null}
                                onChange={handleSubDivisionChange}
                                options={subDivisions.sort((a, b) => a.subDivisionName.localeCompare(b.subDivisionName))

                                    .map((sub) => ({
                                        value: sub.id,
                                        label: capitalizeFirstLetter(sub.subDivisionName,),
                                        subDivisionUid: sub.subDivisionUid,
                                    }))}
                                placeholder="Select Sub Division"
                                isSearchable
                                styles={customStyles}
                                // required
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown}
                                onMenuClose={toggleDropdown}
                                // menuIsOpen={isOpen} 
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: "pointer", marginRight: "10px", }}>

                                            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange' %3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E" alt="Dropdown" style={{ width: "20px", height: "20px" }} />
                                        </div>
                                    ),
                                }}
                            />
                        </div>

                        <div className="existingStock-group-cu-testing-existingStock-repo">
                            <label htmlFor="block">{/*<span className="asterisk">*</span>*/}Block</label>
                            <Select
                                className="search-select"
                                id="block"
                                value={blockId ? {
                                    value: blockId,
                                    label: capitalizeFirstLetter(blocks.find((block) => block.id === blockId)?.blockName)
                                } : null}
                                onChange={handleBlockChange}
                                options={blocks.sort((a, b) => a.blockName.localeCompare(b.blockName))
                                    .map((block) => ({
                                        value: block.id,
                                        label: capitalizeFirstLetter(block.blockName,),
                                        blockUid: block.blockUid,
                                    }))}
                                placeholder="Select Block"
                                isSearchable
                                styles={customStyles}
                                //required
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown}
                                onMenuClose={toggleDropdown}
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                            <img
                                                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                alt="Dropdown"
                                                style={{ width: '20px', height: '20px' }}
                                            />
                                        </div>
                                    ),
                                }}
                            />
                        </div>

                    </div>

                    <div className="existingStock-mainBlock-testing-1-existingStock-repo">
                        <div className="existingStock-group-cu-testing-1-existingStock-repo">
                            <label htmlFor="panchayat" className="district-items-testing-existingStock">{/*<span className="asterisk">*</span>*/}Panchayat</label>
                            <Select
                                className="search-select"
                                id="panchayat"
                                value={panchayatId ? {
                                    value: panchayatId,
                                    label: capitalizeFirstLetter(panchayats.find((p) => p.id === panchayatId)?.panchayatName)
                                } : null}
                                onChange={handlePanchayatChange}
                                options={panchayats.sort((a, b) => a.panchayatName.localeCompare(b.panchayatName))
                                    .map((p) => ({
                                        value: p.id,
                                        label: capitalizeFirstLetter(p.panchayatName,),
                                        panchayatUid: p.panchayatUid,
                                    }))}
                                placeholder="Select Panchayat"
                                isSearchable
                                styles={customStyles}
                                // required
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown}
                                onMenuClose={toggleDropdown}
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                            <img
                                                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                alt="Dropdown"
                                                style={{ width: '20px', height: '20px' }}
                                            />
                                        </div>
                                    ),
                                }}
                            />
                        </div>

                        <div className="existingStock-group-cu-testing-1-existingStock-repo">
                            <label htmlFor="subDivision">{/*<span className="asterisk">*</span>*/}FPS ID</label>
                            {districtId || districtUid ? (
                                <Select
                                    className="search-select"
                                    id="fps"
                                    value={fpsId ? {
                                        value: fpsId,
                                        label: fpsOptions.find((fps) => fps.id === fpsId)?.fpsId  // Use fpsId for label
                                    } : null}
                                    onChange={handleFpsId}
                                    options={fpsOptions.sort((a, b) => a.fpsId.localeCompare(b.fpsId))
                                        .map((fps) => ({
                                            value: fps.id,
                                            label: fps.fpsId,  // Display the fpsId as label
                                        }))}
                                    placeholder="Select FP Shop"
                                    isSearchable
                                    styles={customStyles}
                                    // required
                                    isOpen={isOpen}
                                    onMenuOpen={toggleDropdown}
                                    onMenuClose={toggleDropdown}
                                    components={{
                                        DropdownIndicator: () => (
                                            <div onClick={toggleDropdown} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                                <img
                                                    src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                    alt="Dropdown"
                                                    style={{ width: '20px', height: '20px' }}
                                                />
                                            </div>
                                        ),
                                    }}
                                />
                            ) : (
                                <input className="inspection-search-select-1"
                                    type="text"
                                    placeholder="Enter FPS ID"
                                    value={fpsId}
                                    onChange={(e) => setFpsId(e.target.value)}
                                    style={{ padding: '5px' }}
                                />
                            )}
                        </div>

                        <div className="existingStock-group-cu-testing-1-existingStock-repo">
                            <div className="existingStock-devi-buttons">
                                <button className="existingStock-buttons" onClick={handleClear}
                                    disabled={
                                        // Button is disabled if no districtId or fpsId is provided AND no startDate and endDate are provided
                                        !(fpsId || (districtUid) || (districtUid === null))
                                    }
                                >CLEAR
                                </button>

                                <button
                                    className="existingStock-buttons"
                                    onClick={handleGenerateReport}
                                    disabled={!(fpsId || (districtUid) || (districtUid === null))}
                                >
                                    FETCH DATA
                                </button>
                            </div>

                        </div>

                    </div>

                    <div className="existingStock-mainBlock-testing-2-existingStock-repo">
                        <div className="existingStock-group-cu-testing-2-existingStock-repo">
                            <label htmlFor="startDate" className="district-items-testing-existingStock-repo">From Date</label>
                            <div className="existingStock-setting-existingStock-repo">
                                <input
                                    disabled
                                    type="text"
                                    id="startDate"
                                    className="existingStock-input-repo"
                                    value={format(fixedStartDate, "dd-MM-yyyy")}
                                    readOnly
                                //  onClick={() => setShowCalendar(true)}

                                />
                                <div className="existingStock-icon-test-existingStock-repo" onClick={() => setShowCalendar(true)}>
                                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                        <path d="M7 10l5 5 5-5z" />
                                    </svg> */}
                                </div>
                                {showCalendar && (
                                    <DatePicker
                                        selected={startDate}
                                        onChange={handleStartDateChange}
                                        // onClickOutside={() => setShowCalendar(false)}
                                        inline
                                        minDate={minStartDate} // From January 1st of current year
                                        maxDate={currentDate} // Today
                                        disabled
                                    />
                                )}
                            </div>
                        </div>


                        <div className="existingStock-group-cu-testing-2-existingStock-repo">
                            <label htmlFor="startDate" className="district-items-testing-existingStock-repo">To Date</label>
                            <div className="existingStock-setting-existingStock-repo">
                                <input

                                    type="text"
                                    id="startDate"
                                    className="existingStock-input-repo"
                                    value={endDate ? format(endDate, "dd-MM-yyyy") : ""}
                                    readOnly
                                    //  onClick={() => setShowEndCalendar(true)}
                                    disabled
                                />
                                <div className="existingStock-icon-test-existingStock-repo" onClick={handleEndDateIconClick}>
                                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                        <path d="M7 10l5 5 5-5z" />
                                    </svg> */}
                                </div>
                                {showEndCalendar && (
                                    <DatePicker
                                        selected={endDate}
                                        onChange={handleEndDateChange}
                                        // onClickOutside={() => setShowEndCalendar(false)}
                                        // minDate={startDate} // End date can't be before the start date
                                        // maxDate={currentDate} // End date can't be after today
                                        minDate={fixedStartDate}   // Can't pick before 29-08-2025
                                        maxDate={currentDate}      // Can't pick beyond today
                                        inline
                                        disabled
                                    />
                                )}
                            </div>
                        </div>

                        <div className="existingStock-group-cu-testing-2-existingStock-repo">
                            {/* Conditionally Render GET REPORT Button */}



                            {/* Conditionally Render DOWNLOAD PDF Button */}
                            {(fpsId || (districtUid && startDate && endDate) || (districtUid === null && startDate && endDate)) && showDownloadButton && showTable && (
                                <div className="existingStock-devi-buttons">
                                    {/* <button onClick={generatePDF} className="existingStock-buttons">
                                        DOWNLOAD PDF
                                    </button> */}
                                    {/* <button onClick={generateXl} className="existingStock-buttons">
                                        DOWNLOAD XLSX
                                    </button> */}
                                </div>

                            )}
                        </div>

                    </div>
                </div>
            </div>

            <div>
                <button className="existingStock-button" onClick={handleSubmit}
                    disabled={isLoading || sortedStockData.length === 0 || !(fpsId || (districtUid) || (districtUid === null))}
                // disabled={!(fpsId || (districtUid ) || (districtUid === null ))}
                >
                    Submit
                </button>
            </div>
            <div className="existingStock-entry-repo">
                <table className="existingStock-table-repo">
                    <thead>
                        <tr>
                            <th rowSpan="2">S.No</th>
                            <th rowSpan="2">District</th>
                            <th rowSpan="2">Sub Division</th>
                            <th rowSpan="2">Block</th>
                            <th rowSpan="2">Panchayat</th>
                            <th rowSpan="2" >Officer Name</th>
                            <th rowSpan="2">Date of Inspection</th>
                            <th rowSpan="2">FPS ID</th>
                            <th rowSpan="2" >Dealer Name</th>
                            <th rowSpan="2">Stock Difference (Rice) QTL </th>
                            <th rowSpan="2">Stock Difference (Wheat) QTL </th>
                            <th rowSpan="2">Type of Deviation (Excess / Shortfall)</th>
                            <th rowSpan="2">Less Quantity of Grain Distributed</th>
                            <th rowSpan="2">Bad Quality of Food Grains Distributed</th>
                            <th rowSpan="2">Food Grains Not Distributed for Current Month</th>
                            <th rowSpan="2">Shop Closed</th>
                            <th rowSpan="2">Action Initiated</th>
                            {/* <th rowSpan="2">Status</th> */}
                            <th rowSpan="2">Remarks</th>

                        </tr>
                        {/* <tr>
                            <th>PHH Qty.</th>
                            <th>AAY Qty.</th>
                            <th>PHH Qty.</th>
                            <th>AAY Qty.</th>
                            <th>Rice</th>
                            <th>Wheat</th>
                            <th>Rice</th>
                            <th>Wheat</th>
                        </tr> */}
                    </thead>
                    {showTable && (
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan="17" style={{ textAlign: 'center' }}>
                                        Loading...
                                    </td>
                                </tr>
                            ) : sortedStockData.length > 0 ? (
                                sortedStockData.map((entry, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{capitalizeWords(entry.districtName)}</td>
                                        <td>{capitalizeWords(entry.subDivisionName)}</td>
                                        <td>{capitalizeWords(entry.blockName)}</td>
                                        <td>{capitalizeWords(entry.panchayatName)}</td>
                                        <td className="of-nowrap">{capitalizeWords(entry.officerName) || 'N/A'}</td>
                                        <td>{new Date(entry.dateofInspection).toLocaleDateString('en-GB').replace(/\//g, '-')}</td>
                                        <td>{entry.fpsId}</td>
                                        <td> {capitalizeWords(entry.dealerName || 'N/A')}</td>
                                        <td> {entry.riceDifference || '-'}</td>
                                        <td> {entry.wheatDifference || '-'}</td>
                                        <td>  {entry.typeofDeviation && entry.typeofDeviation !== "No Difference"
                                            ? entry.typeofDeviation
                                            : "-"}
                                            {/* {formatDeviation(
                                                (parseFloat(entry.riceDiff || 0) || 0) + (parseFloat(entry.wheatDiff || 0) || 0)
                                            )} */}
                                        </td>
                                        <td>{entry.lessQuantity === "NO" ? "-" : capitalizeWords(entry.lessQuantity || "N/A")}</td>
                                        <td>{entry.badQuality === "NO" ? "-" : capitalizeWords(entry.badQuality || "N/A")}</td>
                                        <td>{entry.notDistributed === "NO" ? "-" : capitalizeWords(entry.notDistributed || "N/A")}</td>
                                        <td>{(entry.shopClosed === "NO" || entry.shopClosed==="Unknown") ? "-" : capitalizeWords(entry.shopClosed || "N/A")}</td>


                                        {/* Action Taken Dropdown */}
                                        {/* <td>
                                            {entry.actionInitiated ? (
                                                // Show plain text if already set
                                                entry.actionInitiated
                                            ) : (
                                                // Show dropdown only if not set
                                                <select
                                                    value={entry.actionType || ""}
                                                    onChange={(e) =>
                                                        handleDropdownChange(index, "actionType", e.target.value)
                                                    }
                                                >
                                                    <option value="" disabled>Select Action</option>
                                                    <option value="notice">Show Cause Notice</option>
                                                    <option value="revoke">Show Cause Revoked</option>
                                                    <option value="cancel license">Cancellation of License</option>
                                                </select>
                                            )}
                                        </td> */}
                                        <td>

                                            <select
                                                value={entry.actionType || ""}
                                                onChange={(e) =>
                                                    handleDropdownChange(index, "actionType", e.target.value)
                                                }
                                            >
                                                <option value="" disabled>Select Action</option>
                                                <option value="notice">Show Cause Notice</option>
                                                <option value="fir">FIR</option>
                                               {/* <option value="revoke">Show Cause Revoked</option>
                                                <option value="cancel license">Cancellation of License</option> */}
                                            </select>

                                        </td>


                                        {/* Status Dropdown */}
                                        {/* <td>
                                            <select
                                                value={(entry.status || "").trim()}
                                                onChange={(e) =>
                                                    handleDropdownChange(index, "status", e.target.value)
                                                }
                                            >
                                                <option value="" disabled>Select Status</option>
                                                <option value="Open">Open</option>
                                                <option value="Closed">Closed</option>
                                            </select>
                                        </td> */}
                                        <td>

                                            <input
                                                type="text"
                                                value={entry.remarksAction || ""}
                                                onChange={(e) => handleDropdownChange(index, "remarksAction", e.target.value)}
                                            />

                                        </td>




                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="17" style={{ textAlign: 'center', color: 'red' }}>
                                        No Data Available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    )}
                </table>

            </div>

        </div>
    );
}
export default ExistingStockVerificationReport;